import { isSupported, isAutofillSupported, isPlatformAuthenticatorAvailable, getClientCapabilities, getSupport, isRpIdValidForHost, stashPendingEnrollment, takePendingEnrollment, } from './support.js';
import { createLoginMethods } from './login.js';
import { createEnrollmentMethods } from './enrollment.js';
export function createPasskeysNamespace(request, appId) {
    return {
        isSupported,
        isAutofillSupported,
        isPlatformAuthenticatorAvailable,
        getClientCapabilities,
        getSupport,
        isRpIdValidForHost,
        stashPendingEnrollment,
        takePendingEnrollment,
        ...createLoginMethods(request, appId),
        ...createEnrollmentMethods(request),
    };
}
